/**
 * @generated SignedSource<<a6d85eb979f0a3e76cfc50edec8d37c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateCustomerPreferredLanguageInput = {
  id: string;
  preferredLanguage: string;
};
export type CustomerAccountViewUpdateCustomerPreferredLanguageMutation$variables = {
  input: UpdateCustomerPreferredLanguageInput;
};
export type CustomerAccountViewUpdateCustomerPreferredLanguageMutation$data = {
  readonly updateCustomerPreferredLanguage: {
    readonly id: string;
    readonly preferredLanguage: string;
  };
};
export type CustomerAccountViewUpdateCustomerPreferredLanguageMutation = {
  response: CustomerAccountViewUpdateCustomerPreferredLanguageMutation$data;
  variables: CustomerAccountViewUpdateCustomerPreferredLanguageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CustomerAccount",
    "kind": "LinkedField",
    "name": "updateCustomerPreferredLanguage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "preferredLanguage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerAccountViewUpdateCustomerPreferredLanguageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerAccountViewUpdateCustomerPreferredLanguageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5267301f38064d9b8f6a461a1aa770e9",
    "id": null,
    "metadata": {},
    "name": "CustomerAccountViewUpdateCustomerPreferredLanguageMutation",
    "operationKind": "mutation",
    "text": "mutation CustomerAccountViewUpdateCustomerPreferredLanguageMutation(\n  $input: UpdateCustomerPreferredLanguageInput!\n) {\n  updateCustomerPreferredLanguage(input: $input) {\n    id\n    preferredLanguage\n  }\n}\n"
  }
};
})();

(node as any).hash = "1010ce76883abf4553abf8f73bb2dc2e";

export default node;
